module.exports = __webpack_public_path__ + "img/prxd.7c53a579.png";